import { render, staticRenderFns } from "./subPageTwo.vue?vue&type=template&id=4e43ecc1&scoped=true"
import script from "./subPageTwo.vue?vue&type=script&lang=js"
export * from "./subPageTwo.vue?vue&type=script&lang=js"
import style0 from "./subPageTwo.vue?vue&type=style&index=0&id=4e43ecc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e43ecc1",
  null
  
)

export default component.exports